import { IFee } from '@rbi-ctg/menu';

import { FEES } from './constants';
import { IGetStandardizedName, TFeeKeyStandard } from './types';

export const getStandardizedName = ({ name }: IGetStandardizedName): TFeeKeyStandard =>
  FEES[name] ?? name;

export const getFeesByGroup = (fees: IFee[] | null) =>
  (fees ?? []).reduce((acc: Record<string, number>, val: IFee) => {
    const lowerCaseName = val.name.toLowerCase();
    if (!acc[lowerCaseName]) {
      acc[lowerCaseName] = 0;
    }

    acc[lowerCaseName] += val.totalCents;

    return acc;
  }, {});
